module.exports = __webpack_public_path__ + "img/gl2.7886bde6.jpg";